module.exports = __webpack_public_path__ + "static/media/statikkshiv.82972994.png";